// extracted by mini-css-extract-plugin
module.exports = {"title":"horizontalSmallTitle-module--title--2CDxM","subtitle":"horizontalSmallTitle-module--subtitle--2Vypz"};